import React, { useState, useEffect } from "react";
import {
  FiActivity, FiThermometer, FiZap, FiCpu, FiMapPin, FiShield, FiUsers,
} from "react-icons/fi";
import { MdOutlineWaterDrop } from "react-icons/md";
import { MdOutlineBathroom } from "react-icons/md";
import { facilityDummyData } from "../../Data/FacilityData";
import { DashboardHeader } from "../../components/Shared";
import OverviewPanel         from "./panels/OverviewPanel";
import EnvironmentPanel      from "./panels/EnvironmentPanel";
import WaterPanel            from "./panels/WaterPanel";
import ElectricalEnergyPanel from "./panels/ElectricalEnergyPanel";
import PredictivePanel       from "./panels/PredictivePanel";
import AssetTrackingPanel    from "./panels/AssetTrackingPanel";
import SecurityPanel         from "./panels/SecurityPanel";
import OccupancyPanel        from "./panels/OccupancyPanel";
import RestroomPanel         from "./panels/RestroomPanel";
import "../Dashboard.css";
import "./FacilityDashboard.css";

const STORAGE_KEY = "facilityEnabledTabs";

const ALL_TABS = [
  { id: "overview",    label: "Overview",           icon: FiActivity },
  { id: "environment", label: "Environment",         icon: FiThermometer },
  { id: "water",       label: "Water",               icon: MdOutlineWaterDrop },
  { id: "electrical",  label: "Electrical & Energy", icon: FiZap },
  { id: "predictive",  label: "Predictive AI",       icon: FiCpu },
  { id: "occupancy",   label: "Occupancy",           icon: FiUsers },
  { id: "restroom",    label: "Rest Room",           icon: MdOutlineBathroom },
  { id: "assets",      label: "Asset Tracking",      icon: FiMapPin },
  { id: "security",    label: "Security",            icon: FiShield },
];

const getEnabledTabs = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const enabled = JSON.parse(stored);
      return ALL_TABS.filter(t => t.id === "overview" || enabled.includes(t.id));
    }
  } catch (_) {}
  return ALL_TABS;
};

const FacilityDashboard = () => {
  const [tabs, setTabs] = useState(getEnabledTabs);
  const [activeTab, setActiveTab] = useState("overview");
  const d = facilityDummyData;

  // Re-sync tabs when returning from the settings page
  useEffect(() => {
    const sync = () => {
      const updated = getEnabledTabs();
      setTabs(updated);
      setActiveTab(prev => updated.find(t => t.id === prev) ? prev : "overview");
    };
    window.addEventListener("focus", sync);
    return () => window.removeEventListener("focus", sync);
  }, []);

  const renderPanel = () => {
    switch (activeTab) {
      case "overview":    return <OverviewPanel d={d} />;
      case "environment": return <EnvironmentPanel d={d} />;
      case "water":       return <WaterPanel d={d} />;
      case "electrical":  return <ElectricalEnergyPanel d={d} />;
      case "predictive":  return <PredictivePanel d={d} />;
      case "occupancy":   return <OccupancyPanel d={d} />;
      case "restroom":    return <RestroomPanel d={d} />;
      case "assets":      return <AssetTrackingPanel d={d} />;
      case "security":    return <SecurityPanel d={d} />;
      default:            return null;
    }
  };

  return (
    <div className="fm-container">
      {/* Top header with solution dropdown + settings */}
      <DashboardHeader
        currentSolutionType="facility"
        settingsRoute="/dashboard/facility/settings"
      />

      {/* Tab Bar */}
      <div className="fm-tab-bar">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`fm-tab ${activeTab === tab.id ? "fm-tab-active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <tab.icon size={16} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Panel Content */}
      <div className="fm-panel">
        {renderPanel()}
      </div>
    </div>
  );
};

export default FacilityDashboard;
